enum SortOrder {
  ASC = "ASC",
  DESC = "DESC",
}

export default SortOrder;
